import {
  FETCH_CLERKS_LISTING_SUCCESS,
  FETCH_CLERKS_LISTING_FAILURE,
  RESET,
} from "./clerksTypes";

const initialState = {
  allClerks: [],
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLERKS_LISTING_SUCCESS:
      return {
        allClerks: action.payload,
        error: null,
      };
    case FETCH_CLERKS_LISTING_FAILURE:
      return {
        allClerks: [],
        error: action.payload,
      };
    case RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
